import { BreadCrumbs } from '@/shared/ui/Breadcrumbs/Breadcrumbs'
import { PromotionsView } from '@/widgets/Settings/Promotions'

export const PromotionsPage = () => {
  return (
    <>
      <BreadCrumbs />
      <PromotionsView />
    </>
  )
}
